module.exports = __webpack_public_path__ + "static/images/avatar-unlogin.2535dc3.png";